import { CreateUserRequestDTO, EditUserRequestDTO, FindAllUsersResponseDTO, UserDTO, UserFiltersDTO } from "./dto";
import { UserServiceImpl } from "./serviceImpl";

export interface UserService {
    findAllUser(filters: UserFiltersDTO): Promise<FindAllUsersResponseDTO>
    createUser(request: CreateUserRequestDTO): Promise<void>
    deleteUser(id: string): Promise<void>
    findByIdUser(id: string): Promise<UserDTO>
    editUser(id: string, request: EditUserRequestDTO): Promise<void>
}

export function NewUserService(): UserService {
    return new UserServiceImpl();
}
